<template>
	<div class="hello" style="background-color: #f6f6f6;">
		<div class="header">
			<div @click="backJump" style="color: #fff;float: left;margin-top: 10px;margin-left: 10px;">
				<span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
			</div>
			<div class="clear"></div>
			<img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
			<div>
				<h2><span>新</span>增缴费</h2>
			</div>
		</div>
		<div class="center" style="position: relative;">
			<div class="center-top">
				<div class="top_content content">
					<div class="bt">
						<img src="../assets/water.png" >
						<span>水费</span>
					</div>
					<div class="heiall" style="margin-top: 40px;" rule="">
						<span style="color: #8e8e8e">识别编码</span><span style="float: right;"><a href="" style="color: #0f72dd;">忘记识别编码？</a></span>
						<van-field v-model="hh" label="" @blur="tips" style="border-bottom: 1px solid #dee1e5;font-size: 16px;height: 50px;line-height: 50px;" />
					</div>
				</div>
			</div>
<!--			<div class="center-bottom">-->
<!--				<div class="bot_content content">-->
<!--					<div >-->
<!--						<p>请输入手机号</p>-->
<!--						<van-field v-model="phone" type="tel" style="border-bottom: 1px solid #dee1e5;font-size: 16px;"/>-->
<!--						<p>验证码</p>-->
<!--						<van-field v-model="number" type="number" :maxlength="6" style="width:30%;float: left;border-bottom: 1px solid #dee1e5;font-size: 16px;" />-->
<!--						<van-button type="default" style="float: right;margin-top:-15px;width: 40%;" v-show="show" @click="getCode">获取验证码</van-button>-->
<!--						<van-button type="default" style="float: right;margin-top:-15px" v-show="!show" class="count">{{count}} s</van-button>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
		</div>
		<div class="foot">
			<div class="foot-content">
				<van-checkbox v-model="checked">同意<a href="" style="color: #0F72DD;">《生活缴费协议》</a></van-checkbox>
				<van-button @click="fationJump" type="info" :disabled="nextPage" style="margin-top: 20px;width: 100%;border-radius: 10px;height: 50px;">下一步</van-button>
			</div>
		</div>
	</div>
</template>

<script>
  import {getHouse, sendCode, codeYn} from "../common/api/charge";
  import jump from "../common/jump";
	export default {
	  data() {
	    return {
			hh:'',//户号
			number:'',//验证码
			show: true,//验证码倒计时显示
			count: '',//验证码计时
			timer: null,//倒计时
			checked : true,//同意协议
        nextPage:true,//下一页面跳转
			phone:'',//手机号
			devAddress:"",//地址
	    };
	  },
	  mounted(){

	  },
	  methods:{
		  //识别编码的判断
		  tips(){
        getHouse({houseHoldNumber:this.hh}).then((res)=>{
          console.log(res)
          if(res.data.length == 0){
            this.$toast.fail("该识别编码不存在")
            this.nextPage = true
            return
          }
          else if(res.data[0].devType != '1'){
            this.$toast.fail("类型不正确")
            this.nextPage = true
            return
          }
          else{
            this.nextPage = false
          }
			    this.devAddress = res.data[0].actName
          this.tenantId = res.data[0].tenantId
			  })
			  .catch(function (error) {
			    console.log(error);
			  });
		  },
      //返回上一页面
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
		  //跳转确认信息页面
		  fationJump(){
			  if(this.hh == ''){
				  this.$toast.fail("请完善信息");
				  return ;
			  }
        // codeYn({phone:this.phone,code : this.number,}).then((res)=>{
        //   console.log(res)
          // if(res.data == true){
            this.$router.push({
              path: "/water-really",
              query:{
                houseHoldNumber:this.hh,
                devAddress:this.devAddress,
                tenantId:this.tenantId
              }
            })
          // }
          // else{
          //   this.$toast.fail("验证码错误")
          // }
        // })
		  },
      //发送验证码
		  getCode(){
			  console.log(this.phone)
			  if(this.phone == ''){
				  this.$toast.fail("请输入手机号")
				  return ;
			  }
        sendCode({phone:this.phone}).then((res)=>{
				  console.log(res)
				  if(res.data == true){
					  const TIME_COUNT = 60;
					  if (!this.timer) {
					    this.count = TIME_COUNT;
					    this.show = false;
					    this.timer = setInterval(() => {
					    if (this.count > 0 && this.count <= TIME_COUNT) {
					      this.count--;
					     } else {
					      this.show = true;
					      clearInterval(this.timer);
					      this.timer = null;
					     }
					    }, 1000)
					   }
				  }
				  else{
				    this.$toast.fail(res.msg)
          }
			  })
		  }
	  }
	};
</script>

<style scoped>
	.header{
		width: 100%;
		height: 25vh;
		background-color: #295ad0;
	}
	/deep/.van-cell__title{
		    margin: 10px 15px;
	
	}
	.clear{
		clear: both;
	}
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 50px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	p{
		color: #8e8e8e;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.heiall{
		height:80px;
		margin-top: 5px;
		/* line-height: 50px; */
	}
	.center{
		width:90%;
		height:370px;
		margin: 0 auto;
		border-radius: 10px;
		margin-top: -15px;
	}
	.center-top{
		width: 100%;
		height:250px;
		background-color: #fff;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
	}
	.center-bottom{
		width: 100%;
		height:200px;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		background-color: #fff;
		border-radius: 10px;
		margin-top: 50px;
	}
	.content {
		width: 80%;
		margin: 0 auto;
	}
	.bot_content{
		margin-top: 28px;
	}
	.foot{
		height: 130px;
		border-top:1px solid #dee1e5 ;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		background-color: #fff;
	}
	.foot-content{
		width: 90%;
		margin: 0 auto;
		margin-top:20px;
		height: 110px;
		    
	}
</style>
